import { render, staticRenderFns } from "./productunits.vue?vue&type=template&id=b5aedc68&scoped=true"
import script from "./productunits.vue?vue&type=script&lang=js"
export * from "./productunits.vue?vue&type=script&lang=js"
import style0 from "./productunits.vue?vue&type=style&index=0&id=b5aedc68&prod&scoped=true&lang=css"
import style1 from "./productunits.vue?vue&type=style&index=1&id=b5aedc68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5aedc68",
  null
  
)

export default component.exports